module.exports = __webpack_public_path__ + "backbone.5fa80b.svg";